// extracted by mini-css-extract-plugin
export default {"infoBar":"SaleInfo_infoBar__APeSZ","tabList":"SaleInfo_tabList__2CtKD","tab":"SaleInfo_tab__adw-t","tabSelected":"SaleInfo_tabSelected__kq8bm","heading":"SaleInfo_heading__4+8CI"};